<div class="wrapper-logs">
    <app-advanced-gridview [dataSource]="dataSource" [size]="size" [model]="filteredTableModel" [menuItems]="menuItems" [contextualMenu]="false"></app-advanced-gridview>
</div>
